<template>
  <el-row>
    <el-col>
      <el-form :model="form" :inline="true" size="mini">
        <el-form-item label="用户">
          <el-input
            clearable
            v-model="form.phone"
            placeholder="请输入用户手机号"
            @keyup.enter.native="handleSearch"
          />
        </el-form-item>
        <el-form-item label="应用类型">
          <el-select v-model="form.tripartiteResourceTypeArr" clearable filterable multiple>
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in appOptions"
              :key="item.label"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="时间">
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="form.dateArr"
            type="daterange"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="dateChange"
            :clearable="false"
            :picker-options="pickerOptions"
          />
        </el-form-item>
        <el-form-item label="供应商">
          <yd-merchant-selector v-model="form.merchantId" />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            :disabled="loading"
            @click="handleSearch"
            :loading="loading"
          >
            查询
          </el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            :disabled="loading"
            @click="handleReset"
            :loading="loading"
          >
            重置
          </el-button>
          <el-button
            :loading="exportLoading"
            type="primary"
            icon="el-icon-download"
            :disabled="loading"
            @click="handleExport"
          >
            导出
          </el-button>
          <el-button
            type="primary"
            icon="el-icon-upload2"
            :disabled="loading"
            @click="openUploadDialog"
          >
            营销短信导入
          </el-button>
          <el-button type="primary" @click="viewLog"> 导入日志 </el-button>
        </el-form-item>
      </el-form>
    </el-col>
  </el-row>
</template>

<script >
import { inject, computed } from '@vue/composition-api';
import { Message } from 'element-ui';
import dayjs from 'dayjs';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const loading = inject('loading');
  const form = inject('searchParam');
  const search = inject('search');
  const handleReset = inject('reset');
  const handleExport = inject('handleExport');
  const viewLog = inject('viewLog');
  // 字典
  const dicOptions = inject('dicOptions', {});
  const exportLoading = inject('exportLoading');
  const openUploadDialog = inject('openUploadDialog');

  // 会员等级
  const appOptions = computed(() => {
    return dicOptions.value && dicOptions.value.appTypeArr ? dicOptions.value.appTypeArr : [];
  });
  const pickerOptions = {
    disabledDate(time) {
      return time.getTime() > Date.now();
    }
  };

  // 日期值改变事件
  const dateChange = arr => {
    if (Array.isArray(arr) && arr.length === 2) {
      form.value.startDate = arr[0];
      form.value.endDate = arr[1];
      return;
    }
    form.value.startDate = undefined;
    form.value.endDate = undefined;
  };

  // 搜索事件
  const handleSearch = () => {
    if (Array.isArray(form.value.tripartiteResourceTypeArr)) {
      form.value.tripartiteResourceType = form.value.tripartiteResourceTypeArr.join(',');
    } else {
      form.value.tripartiteResourceType = undefined;
    }
    if (form.value.startDate && form.value.endDate) {
      const maxD = dayjs(form.value.startDate).add(365, 'day');
      if (dayjs(form.value.endDate).isAfter(maxD)) {
        Message.error('查询的时间跨度不能超过365天');
        return;
      }
    }
    search();
  };
  return {
    loading,
    form,
    handleReset,
    handleExport,
    viewLog,
    exportLoading,
    openUploadDialog,
    appOptions,
    pickerOptions,
    dateChange,
    handleSearch
  };
};
export default __sfc_main;
</script>

<style lang="scss" scoped></style>
